export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/watercolor_pattern.0158998.svg";